import { render, staticRenderFns } from "./app.loader.vue?vue&type=template&id=5db64ba6&scoped=true&"
import script from "./app.loader.vue?vue&type=script&lang=js&"
export * from "./app.loader.vue?vue&type=script&lang=js&"
import style0 from "./app.loader.vue?vue&type=style&index=0&id=5db64ba6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db64ba6",
  null
  
)

export default component.exports